<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-to-bottom`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 25V5a1 1 0 011-1h2a1 1 0 011 1v20h5.982c1.191 0 1.838 1.394 1.068 2.304l-7.981 9.433a1.4 1.4 0 01-2.138 0l-7.981-9.433c-.77-.91-.123-2.304 1.069-2.304H22zm21 15a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38z"/></svg>
</template>
<script>

export default {
  name: 'IconToBottom',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
